import { render, staticRenderFns } from "./CreateProduct.vue?vue&type=template&id=16699f9c&scoped=true"
import script from "./CreateProduct.vue?vue&type=script&lang=js"
export * from "./CreateProduct.vue?vue&type=script&lang=js"
import style0 from "./CreateProduct.vue?vue&type=style&index=0&id=16699f9c&prod&scoped=true&lang=css"
import style1 from "./CreateProduct.vue?vue&type=style&index=1&id=16699f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16699f9c",
  null
  
)

export default component.exports